import api from "./api";
export interface PaymentType {
  billId: number;
  paymentModeId: number;
  date: string;
  dueDate: string;
  reference: string;
  amount: number;
  currencyId: number;
  exchangeRate: number;
  isPosted: boolean;
  postedDate: string | null;
  notes: string;
  sessionId: string | null;
}

export const getPayments = async (
  q: number | string,
  from: string,
  to: string
) => {
  return await api.get(`payments?q=${q}&from=${from}&to=${to}`);
};
export const getPayment = async (id: number | undefined) => {
  return await api.get(`/payments/${id}`);
};
export const createPayment = async (body: PaymentType) => {
  return await api.post(`/payments`, body);
};
export const updatePayment = async (id: number, body: PaymentType) => {
  return await api.put(`/payments/${id}`, body);
};

export const deletePayment = async (id: number | undefined) => {
  return await api.delete(`/payments/${id}`);
};
export const getSuppliersPayments = async (suppliersId: string | undefined) => {
  return await api.get(`/payments/suppliers/${suppliersId}`);
};
